export enum UserStatus {
    Active = 'active',
    Created = 'created',
    VerificationPending = 'verification_pending',
    Deleted = 'deleted'
}
